import React from 'react';
import MuiRadioGroup, {
  RadioGroupProps as MuiRadioGroupProps,
} from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    flexDirection: 'row',
  },
});

interface IProps extends MuiRadioGroupProps {
  inline?: boolean;
  label?: string;
}

export const RawRadioGroup: React.FunctionComponent<IProps> = (
  props: IProps
) => {
  const { label, inline } = props;
  const customClasses = useStyles();

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <MuiRadioGroup {...props} classes={inline ? customClasses : {}}>
        {props.children}
      </MuiRadioGroup>
    </FormControl>
  );
};
